<h2 mat-dialog-title>{{ 'success_request.title' | translate }}</h2>
<p>{{ 'success_request.descr' | translate }}</p>